import { NXBank, NXCash, NXCreditCard, NXPaypal } from '../../icons';
import { 
  NXCancelled, NXPending, NXConfirmed, NXShipped,
  NXDelivered, NXReturned, NXPacked, NXActive,
  NXAwaitingSelection, NXGiftCard, NXDue, NXApproved,
  NXPendingReturn, NXDraft, NXPublished, NXArchived,
  NXReserved, NXReleased, NXFailed, NXNotReserved, NXDispatched, NXPartialCharged, NXFullCharged, NXOverCharged,
  NXDueOnReceipt, NXDueOnFixedDate, NXDueOnInstallment, NXDuleOnFullfillment
} from './statusIcon';

const TextBadge = ({ value, label, size = 'md' }: { value: string, label?: string, size?: string }) => {
  // Function to determine the className based on the text
  const getClassnameAndIcon = (status: string): { className: string, icon: JSX.Element | null } => {
    if (!status) {
      return { className: "", icon: null };
    }

    
    switch (status.toLowerCase()) {
      case "cancelled":
        return { className: "text-red-500 bg-red-50", icon: <NXCancelled className="text-red-500" /> };
      case "pending":
        return { className: "text-orange-500 bg-orange-50", icon: <NXPending className="text-orange-500" /> };
      case "confirmed":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXConfirmed className={`text-[#10B981]`} /> };
      case "shipped":
        return { className: "text-purple-500 bg-purple-50", icon: <NXShipped className="text-purple-500" /> };
      case "delivered":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXDelivered className={`text-[#10B981]`} /> };
      case "returned":
        return { className: "text-yellow-500 bg-yellow-50", icon: <NXReturned className="text-yellow-500" /> };
      case "packed":
        return { className: "text-orange-500 bg-orange-50", icon: <NXPacked className="text-orange-500" /> };
      case "active":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXActive className={`text-[#10B981]`} /> };
      case "awaiting_selection":
        return { className: "text-yellow-500 bg-yellow-50", icon: <NXAwaitingSelection className="text-yellow-500" /> };
      case "gift_card":
        return { className: "text-yellow-500 bg-yellow-50", icon: <NXGiftCard className="text-yellow-500" /> };
      case "due":
        return { className: "text-gray-600 bg-gray-100", icon: <NXDue className="text-gray-600" /> };
      case "partial":
        return { className: "text-yellow-500 bg-yellow-50", icon: <NXPartialCharged className="text-yellow-500" />};
      case "full":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXFullCharged className={`text-[#10B981]`} /> };
      case "overcharged":
        return { className: "text-red-500 bg-red-50", icon: <NXOverCharged className="text-red-500" /> };
      case "approved":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXApproved className={`text-[#10B981]`} /> };
      case "pending_return":
        return { className: "text-orange-500 bg-orange-50", icon: <NXPendingReturn className="text-orange-500" /> };
      case "draft":
        return { className: "text-yellow-500 bg-yellow-50", icon: <NXDraft className="text-yellow-500" /> };
      case "published":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXPublished className={`text-[#10B981]`} /> };
      case "archived":
        return { className: "text-red-500 bg-red-50", icon: <NXArchived className="text-red-500" /> };
      case "credit_card":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXCreditCard className={`text-[#10B981]`} /> };
      case "bank_transfer":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXBank className={`text-[#10B981]`} /> };
      case "cash_on_delivery":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXCash className={`text-[#10B981]`} /> };
      case "paypal":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXPaypal className={`text-[#10B981]`} /> };
      case "reserved":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXReserved className={`text-[#10B981]`} /> };
      case "released":
        return { className: `text-[#10B981] bg-[#D1FAE5]`, icon: <NXReleased className={`text-[#10B981]`} /> };
      case "failed":
        return { className: "text-red-500 bg-red-50", icon: <NXFailed className="text-red-500" /> };
      case "not_required":
        return { className: "text-red-500 bg-red-50", icon: <NXNotReserved className="text-red-500" /> };
      case "dispatched":
        return { className: "text-purple-500 bg-purple-50", icon: <NXDispatched className="text-purple-500" /> };
      case "due_on_receipt":
        return { className: "text-gray-600 bg-gray-100", icon: <NXDueOnReceipt className="text-gray-600" /> };
      case "fixed_date":
        return { className: "text-gray-600 bg-gray-100", icon: <NXDueOnFixedDate className="text-gray-600" /> };
      case "due_on_fullfillment":
        return { className: "text-gray-600 bg-gray-100", icon: <NXDuleOnFullfillment className="text-gray-600" /> };
      case "due_on_installment":
        return { className: "text-gray-600 bg-gray-100", icon: <NXDueOnInstallment className="text-gray-600" /> };
      default:
        return { className: "", icon: null };
    }
  };

  // Get className based on the text
  const { className, icon } = getClassnameAndIcon(value);
  const sizeClass = size === 'md' 
    ? 'px-2 py-1 text-base' 
    : size === 'lg' 
    ? 'px-3 py-2 text-lg' 
    : size === 'sm' 
    ? 'px-1 py-px text-sm'
    : 'px-3 py-1 text-base';

  return (
    <span className={`inline-flex items-center rounded-md font-normal ${className} ${sizeClass}`}>
      {icon && <span className="mr-2">{icon}</span>}
      {label ? label : value?.replace(/_/g, ' ').toLowerCase()}
    </span>
  );
};

export default TextBadge;